/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonStratOnepagerInfo,
    JsonStratOnepagerInfoFromJSON,
    JsonStratOnepagerInfoFromJSONTyped,
    JsonStratOnepagerInfoToJSON,
} from './JsonStratOnepagerInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonStratOnepagerInfo
 */
export interface ApiResultOfJsonStratOnepagerInfo {
    /**
     * 
     * @type {JsonStratOnepagerInfo}
     * @memberof ApiResultOfJsonStratOnepagerInfo
     */
    data?: JsonStratOnepagerInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratOnepagerInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonStratOnepagerInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratOnepagerInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratOnepagerInfo
     */
    result?: ApiResultOfJsonStratOnepagerInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonStratOnepagerInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonStratOnepagerInfoFromJSON(json: any): ApiResultOfJsonStratOnepagerInfo {
    return ApiResultOfJsonStratOnepagerInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonStratOnepagerInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonStratOnepagerInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonStratOnepagerInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonStratOnepagerInfoToJSON(value?: ApiResultOfJsonStratOnepagerInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonStratOnepagerInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

